import { useLocation } from "react-router-dom";
import TableLayout from "../../components/TableLayout";
import { useFetchData } from "../../hooks/useFetchData";
import { API_URL } from "../../utils/constant";
import React, {useState} from "react";

const headers = [
  {
    key: "unit_name",
    parent: "base_unit",
    name: "Base Unit",
  },
  {
    key: "base_qty",
    name: "Base Quantity",
  },
  {
    key: "unit_name",
    parent: "converted_unit",
    name: "Converted Unit",
  },
  {
    key: "converted_qty",
    name: "Converted Quantity",
  },
];

export default function UnitConversionList() {
  const location = useLocation();
  const currentPath = location.pathname;
   const [searchValue, setSearchValue] = useState("");

//  const handleSearch = (value) => {
//     setSearchValue(value.trim())
//     setQuery({
//       search: value.trim(),
//     });
//   };
 const handleSearch = (value) => {
    const trimmed = value.trim();
    if(trimmed.length > 0){
      setSearchValue(trimmed);
      setQuery({
        search: trimmed,
      });
    }else{
        setQuery({
      
    });
    }
  };

  const { data, setCurrentPage, setQuery, reload } = useFetchData({
    url: API_URL + "/uoc",
    defaultQuery: "status=ACTIVE",
  });
  const nothingFoundAfterSearch =
    searchValue && Array.isArray(data?.results) && data.results.length === 0;

  return (
    <TableLayout
      title="Unit of Conversion List"
      data={data}
      headers={headers}
      idKey="uoc_id"
      endPoint="/uoc"
      removeDetails={true}
      module="Unit"
      subModule="Unit of Conversion"
      setCurrentPage={setCurrentPage}
      hasSearch
      hasCreate
      hasActions
      //hasPointChange
      createPath={`/unit/conversion/create`}
      currentPath={currentPath}
      onSearch={(value) => handleSearch(value)}
      disabledSerial
      //pointChangeModel="UOC"
      reload={reload}
      searchValue={searchValue}
      nothingFoundAfterSearch={nothingFoundAfterSearch}
      setQuery={setQuery}
    />
  );
}
